import { ofType } from "redux-observable";
import { mergeMap, map, catchError } from "rxjs/operators";
import { of } from "rxjs";
import {
  deleteReport,
  getRepoRoles,
  getReports,
  getRoles,
  postGeneratePreview,
  postReport,
  putReport,
  putRoles,
} from "./services";
import {
  actionTypes,
  deleteReportFailure,
  deleteReportSuccess,
  getRepoRolesFailure,
  getRepoRolesSuccess,
  getReportsFailure,
  getReportsSuccess,
  getRolesFailure,
  getRolesSuccess,
  postGeneratePreviewFailure,
  postGeneratePreviewSuccess,
  postReportFailure,
  postReportSuccess,
  putReportFailure,
  putReportSuccess,
  putRolesFailure,
  putRolesSuccess,
} from "./actions";

const fetchGetReportEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_REPORTS),
    mergeMap(() =>
      getReports().pipe(
        map((response: any) => getReportsSuccess(response)),
        catchError((error: any) => of(getReportsFailure(error)))
      )
    )
  );

const fetchGetRolesEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_ROLES),
    mergeMap(() =>
      getRoles().pipe(
        map((response: any) => getRolesSuccess(response)),
        catchError((error: any) => of(getRolesFailure(error)))
      )
    )
  );

const fetchGetRepoRolesEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_REPO_ROLES),
    mergeMap((action: any) =>
      getRepoRoles(action.payload).pipe(
        map((response: any) => getRepoRolesSuccess(response)),
        catchError((error: any) => of(getRepoRolesFailure(error)))
      )
    )
  );

const postReportEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.POST_REPORT),
    mergeMap((action: any) =>
      postReport(action.payload).pipe(
        map((response: any) => postReportSuccess(response)),
        catchError((error: any) => of(postReportFailure(error)))
      )
    )
  );

const putReportEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.PUT_REPORT),
    mergeMap((action: any) =>
      putReport(action.payload.data, action.payload.id).pipe(
        map((response: any) => putReportSuccess(response)),
        catchError((error: any) => of(putReportFailure(error)))
      )
    )
  );

const putRolesEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.PUT_ROLES),
    mergeMap((action: any) =>
      putRoles(action.payload.id, action.payload.roles).pipe(
        map((response: any) => putRolesSuccess(response)),
        catchError((error: any) => of(putRolesFailure(error)))
      )
    )
  );

const deleteReportEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.DELETE_REPORT),
    mergeMap((action: any) =>
      deleteReport(action.payload).pipe(
        map((response: any) => deleteReportSuccess(response)),
        catchError((error: any) => of(deleteReportFailure(error)))
      )
    )
  );

const postGeneratePreviewEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.POST_GENERATE),
    mergeMap((action: any) =>
      postGeneratePreview(action.payload).pipe(
        map((response: any) => postGeneratePreviewSuccess(response)),
        catchError((error: any) => of(postGeneratePreviewFailure(error)))
      )
    )
  );

export default [
  fetchGetReportEpic,
  fetchGetRolesEpic,
  fetchGetRepoRolesEpic,
  postReportEpic,
  putReportEpic,
  putRolesEpic,
  deleteReportEpic,
  postGeneratePreviewEpic,
];
